<div class="government-information-container">
  <div class="form-container" [formGroup]="accountGovtInfoForm">
    <div *ngFor="let field of formFields">
      <div
        *ngIf="
          field.type === formFieldType.input ||
          field.type === formFieldType.select
        "
        class="form-field-container">
        <mat-form-field
          class="mat-md remove-subscript-wrapper custom-select mat-select-variants"
          appearance="outline">
          <mat-icon
            matPrefix
            class="dropdown-icon"
            *ngIf="field.type === formFieldType.select">
            {{ actionIcons.keyboardDownArrow }}
          </mat-icon>
          <mat-label>{{ field.label }}</mat-label>
          <div
            *ngIf="
              field.type === formFieldType.select && field.id === 'salesPerson'
            ">
            <input
              id="govtInfoSalesPerson"
              appOnOptionSelectedTabNewInput
              matInput
              formControlName="salesPerson"
              [matAutocomplete]="salesPersonAutoComplete"
              (input)="onSalesPersonInput()"
              (blur)="onSalesPersonBlur()" />
            <mat-autocomplete
              #salesPersonAutoComplete="matAutocomplete"
              (optionSelected)="
                onTypeSelected(
                  accountGovtInfoForm.get('salesPerson')?.value,
                  salesPersonData,
                  'salesPersonId'
                )
              "
              appOnOptionSelectedTabNewInput
              [controlId]="'govtInfoSalesPerson'">
              <mat-option
                *ngFor="let item of filterSalesPersonOption | async"
                [value]="item.name">
                {{ item.name }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div
            *ngIf="
              field.type === formFieldType.select &&
              field.id === 'invoiceFileFormat'
            ">
            <mat-select
              formControlName="{{ field.id }}"
              (selectionChange)="onBillingTypeSelectionChange($event)">
              @for (item of invoiceTypeDropdownValues; track item['id']) {
                <mat-option [value]="item['id']">{{ item['name'] }}</mat-option>
              }
            </mat-select>
          </div>
          <div
            *ngIf="
              field.type === formFieldType.select && field.id === 'billingType'
            ">
            <mat-select
              formControlName="{{ field.id }}"
              multiple
              (selectionChange)="onBillingTypeSelectionChange($event)">
              @for (option of billingTypeData; track option.id) {
                <mat-option value="{{ option.id }}" [disabled]="isBillingOptionDisabled(option.id.toString())">{{
                  option.name
                }}</mat-option>
              }
            </mat-select>
          </div>
        <!-- for service type and delivery agent field -->          
           <div
            *ngIf="
              field.type === formFieldType.select && field.id === 'serviceTypes'
            ">
            <mat-select
              formControlName="{{ field.id }}"
              multiple
              panelClass="service-type-select-panel"
              (openedChange)="onServiceTypeDropdownOpened($event)"
              (selectionChange)="onServiceTypeSelectionChange()">
              <mat-select-trigger>
                {{ getServiceTypeTriggerLabel() }}
              </mat-select-trigger>
              <mat-option
                class="service-type-search-option no-checkbox"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()">
                <div class="service-type-search-wrapper">
                  <input
                    #serviceTypeSearchInput
                    type="text"
                    class="service-type-search-input"
                    placeholder="Search Service Type"
                    aria-label="Search service types"
                    autocomplete="off"
                    [formControl]="serviceTypeSearchCtrl"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()" />
                </div>
              </mat-option>
              <mat-option
                [value]="governmentInfoTbdDisplay"
                [class.service-type-option-hidden]="
                  !isServiceTypeTbdOptionVisible()
                ">
                {{ governmentInfoTbdDisplay }}
              </mat-option>
              @for (option of serviceTypeDropDownValues; track option.id) {
                @if (option.id !== governmentInfoTbdDisplay) {
                  <mat-option
                    value="{{ option.id }}"
                    [class.service-type-option-hidden]="
                      !isServiceTypeOptionVisible(option)
                    ">{{
                    option.name
                  }}</mat-option>
                }
              }
              @if (!hasVisibleServiceTypeOptions()) {
                <mat-option class="no-checkbox" disabled>
                  {{ noMatchingServiceTypes }}
                </mat-option>
              }
            </mat-select>
          </div>
           <div
            *ngIf="
              field.type === formFieldType.select && field.id === 'deliveryAgentId'
            ">
            <input
              matInput
              id="govtInfoDeilveryAgent"
              appOnOptionSelectedTabNewInput
              formControlName="deliveryAgentId"
              [matAutocomplete]="deliveryAgentAutoComplete"
              (input)="onDeliveryAgentInput()"
              (blur)="onDeliveryAgentBlur()" />
            <mat-autocomplete
              #deliveryAgentAutoComplete="matAutocomplete"
              (optionSelected)="onDeliveryAgentSelected($event, 'deliveryAgentId')"
              appOnOptionSelectedTabNewInput
              [controlId]="'govtInfoDeilveryAgent'">
              <mat-option
                *ngFor="let item of filteredDeliveryAgentsList | async"
                [value]="item.code">
               {{ item.code }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div
            *ngIf="
              field.type === formFieldType.select && field.id === 'invoiceType'
            ">
            <mat-select
              formControlName="{{ field.id }}"
              (selectionChange)="dispatchBusinessFormChanges()">
              @for (item of invoiceTypeLookupData; track item.id) {
                <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
          </div>
          <div
            *ngIf="
              field.type === formFieldType.select && field.id === 'isAutoRate'
            ">
            <mat-select
              formControlName="{{ field.id }}"
              (selectionChange)="dispatchBusinessFormChanges()">
              @for (item of autoRateOptions; track item.id) {
                <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
          </div>
          <input
            *ngIf="field.type === formFieldType.input"
            matInput
            formControlName="{{ field.id }}"
            (blur)="dispatchBusinessFormChanges()" />
          <app-field-clear-suffix
            matSuffix
            *ngIf="field.type === formFieldType.select"
            [control]="accountGovtInfoForm.get(field.id)"
            [multiple]="
              field.id === 'billingType' || field.id === 'serviceTypes'
            "
            [emptyValue]="
              field.id === 'serviceTypes'
                ? governmentInfoServiceTypesTbdValue
                : undefined
            "
            [autocomplete]="
              field.id === 'salesPerson' || field.id === 'deliveryAgentId'
            "
            (cleared)="
              (field.id === 'invoiceType' || field.id === 'isAutoRate') &&
                dispatchBusinessFormChanges()
            " />
          <app-svg-icon
            *ngIf="checkControlForError(field.id)"
            matSuffix
            [iconName]="'infoCircle'"
            [isStaticSvg]="true"
            class="cursor info-icon-error"
            (click)="fetchWidth($event, field.id)"
            (keydown)="$event.stopPropagation()">
          </app-svg-icon>
          <app-custom-error-tooltip
            *ngIf="
              checkControlForError(field.id) &&
              setGovernmentInfoErrorTooltip[field.id]
            "
            [tooltipWidth]="setGovernmentInfoWidth[field.id]"
            [tooltipText]="fetchErrorMessages(field.id)"
            (tooltipCloseClicked)="
              commonService.closeErrorTooltip(
                field.id,
                setGovernmentInfoErrorTooltip
              )
            ">
          </app-custom-error-tooltip>
        </mat-form-field>
      </div>
      <div
        *ngIf="field.type === formFieldType.multiSelectAutoComplete"
        class="chips-autocomplete-container">
        <mat-checkbox
          *ngIf="field.id === 'selectEmailsforGatewayNotification'"
          class="basic-checkbox"
          (change)="onSameAsInvoiceEmailChange($event)"
          [checked]="areEmailsSame()"
          [disabled]="
            pageMode === ModeIcons.view ||
            !emailsForInvoiceNotifications?.length
          ">
          Same as Invoice Email Addresses
        </mat-checkbox>

        <mat-form-field
          class="chip-autocomplete-field remove-subscript-wrapper"
          appearance="outline"
          *ngIf="field.id === 'selectEmailsForInvoiceNotification'">
          <mat-label>{{ field.label }}</mat-label>
          <mat-chip-grid #chipGrid1 aria-label="email selection">
            <mat-chip-row
              *ngFor="let email of emailsForInvoiceNotifications; let i = index"
              [removable]="pageMode !== ModeIcons.view"
              (removed)="removeForInvoiceEmail(email)">
              {{ email }}
              <button matChipRemove [attr.aria-label]="'remove ' + email" *ngIf="pageMode !== ModeIcons.view">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input
            placeholder="Select Email"
            #emailInput
            [formControl]="emailCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipGrid1"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addForInvoiceEmail($event)"
            [disabled]="pageMode === ModeIcons.view" />
          <app-svg-icon
            *ngIf="emailCtrl.touched && emailCtrl.errors"
            matSuffix
            #invoiceEmailErrorIcon
            [iconName]="'infoCircle'"
            [isStaticSvg]="true"
            class="cursor info-icon-error"
            (click)="fetchWidth($event, 'emailCtrl')"
            (keydown)="$event.stopPropagation()">
          </app-svg-icon>
          <app-custom-error-tooltip
            *ngIf="
              emailCtrl.touched &&
              emailCtrl.errors &&
              setGovernmentInfoErrorTooltip['emailCtrl']
            "
            [tooltipWidth]="setGovernmentInfoWidth['emailCtrl']"
            [tooltipText]="emailErrorMessage"
            (tooltipCloseClicked)="
              commonService.closeErrorTooltip(
                'emailCtrl',
                setGovernmentInfoErrorTooltip
              )
            ">
          </app-custom-error-tooltip>
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="selectedForInvoiceEmail($event)">
            <mat-option
              *ngFor="let data of filterUserInvoiceEmailData | async"
              [value]="data">
              {{ data.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field
          class="chip-autocomplete-field remove-subscript-wrapper"
          appearance="outline"
          *ngIf="field.id === 'selectEmailsforGatewayNotification'">
          <mat-label>{{ field.label }}</mat-label>
          <mat-chip-grid #chipGrid2 aria-label="email selection">
            <mat-chip-row
              *ngFor="let email of emailsForGatewayNotifications; let i = index"
              [removable]="pageMode !== ModeIcons.view"
              (removed)="removeForGatewayEmail(email)">
              {{ email }}
              <button matChipRemove [attr.aria-label]="'remove ' + email" *ngIf="pageMode !== ModeIcons.view">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input
            placeholder="Select Email"
            #emailInput2
            [formControl]="emailCtrl2"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipGrid2"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addForGatewayEmail($event)"
            [disabled]="pageMode === ModeIcons.view" />
          <app-svg-icon
            *ngIf="emailCtrl2.touched && emailCtrl2.errors"
            matSuffix
            #gatewayEmailErrorIcon
            [iconName]="'infoCircle'"
            [isStaticSvg]="true"
            class="cursor info-icon-error"
            (click)="fetchWidth($event, 'emailCtrl2')"
            (keydown)="$event.stopPropagation()">
          </app-svg-icon>
          <app-custom-error-tooltip
            *ngIf="
              emailCtrl2.touched &&
              emailCtrl2.errors &&
              setGovernmentInfoErrorTooltip['emailCtrl2']
            "
            [tooltipWidth]="setGovernmentInfoWidth['emailCtrl2']"
            [tooltipText]="emailErrorMessage"
            (tooltipCloseClicked)="
              commonService.closeErrorTooltip(
                'emailCtrl2',
                setGovernmentInfoErrorTooltip
              )
            ">
          </app-custom-error-tooltip>
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="selectedForGatewayEmail($event)">
            <mat-option
              *ngFor="let data of filterUserGatewayEmailData | async"
              [value]="data">
              {{ data.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="master-billing-container" *ngIf="isMasterBillingVisible()">
    <div class="header">
      <span class="ibc-heading-h7-bold-primary">Master Shipment Billing</span>
    </div>
    <div class="content">
      @for (tile of masterShipmentBillingTile; track tile.header) {
        <div class="tile" [formGroup]="mapTileToForm(tile.header)">
          <div class="tile-header">
            <span>{{ tile.header }}</span>
          </div>
          <div class="tile-content">
            @for (formField of tile.form; track formField.id) {
              @if (formField.type === 'input') {
                <mat-form-field
                  class="mat-md remove-subscript-wrapper"
                  appearance="outline">
                  <mat-label>{{ formField.label }}</mat-label>
                  <input
                    matInput
                    [formControlName]="formField.id"
                    (blur)="dispatchBusinessFormChanges()" />
                </mat-form-field>
              } @else if (formField.type === 'select') {
                <mat-form-field
                  class="mat-md custom-select mat-select-variants remove-subscript-wrapper capitalize-options"
                  appearance="outline">
                  <mat-label>{{ formField.label }}</mat-label>
                  <mat-select
                    [formControlName]="formField.id"
                    (selectionChange)="dispatchBusinessFormChanges()">
                    @if (
                      formField.id === 'recoveryWeightMetric' ||
                      formField.id === 'deliveryWeightMetric'
                    ) {
                      @for (
                        option of weightMetricDropdownValues;
                        track option['id']
                      ) {
                        <mat-option
                          [value]="option['id']"
                          class="capitalize-text"
                          >{{ option['name'] }}</mat-option
                        >
                      }
                    }
                  </mat-select>
                  <mat-icon matPrefix class="dropdown-icon">
                    {{ actionIcons.keyboardDownArrow }}
                  </mat-icon>
                  <app-field-clear-suffix
                    matSuffix
                    [control]="mapTileToForm(tile.header).get(formField.id)" />
                </mat-form-field>
              } @else if (formField.type === 'autocomplete') {
                <mat-form-field
                  class="mat-md remove-subscript-wrapper"
                  appearance="outline">
                  <mat-label>{{ formField.label }}</mat-label>
                  <mat-icon matPrefix class="dropdown-icon">
                    {{ actionIcons.keyboardDownArrow }}
                  </mat-icon>
                  <input
                    matInput
                    [formControlName]="formField.id"
                    [matAutocomplete]="autoCompleteField"
                    (input)="onAutocompleteInput(formField.id)"
                    (blur)="dispatchBusinessFormChanges()"
                    [attr.id]="'autocomplete-' + formField.id"
                    [attr.data-field-type]="formField.id" />
                  <mat-autocomplete
                    #autoCompleteField="matAutocomplete"
                    (keydown)="$event.stopPropagation()"
                    (optionSelected)="
                      onAutocompleteOptionSelected(formField.id, $event)
                    ">
                    <mat-option
                      *ngFor="
                        let option of getFilteredAutocompleteOptions(
                          formField.id
                        ) | async
                      "
                      [value]="option.name">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <app-field-clear-suffix
                    matSuffix
                    [control]="mapTileToForm(tile.header).get(formField.id)"
                    [autocomplete]="true" />
                  <app-svg-icon
                    *ngIf="checkControlForError(formField.id)"
                    matSuffix
                    [iconName]="'infoCircle'"
                    [isStaticSvg]="true"
                    [isFrom]="'Page'"
                    class="cursor info-icon-error"
                    (click)="fetchWidth($event, formField.id)"
                    (keydown)="$event.stopPropagation()"></app-svg-icon>
                  <app-custom-error-tooltip
                    *ngIf="
                      checkControlForError(formField.id) &&
                      setGovernmentInfoErrorTooltip[formField.id]
                    "
                    [tooltipWidth]="setGovernmentInfoWidth[formField.id]"
                    [tooltipText]="fetchErrorMessages(formField.id)"
                    (tooltipCloseClicked)="
                      commonService.closeErrorTooltip(
                        formField.id,
                        setGovernmentInfoErrorTooltip
                      )
                    ">
                  </app-custom-error-tooltip>
                </mat-form-field>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="customer-service-grid">
    <app-information-note
      *ngIf="isUfoCustomerServiceNotApplicable"
      [message]="popupMessages.ufoCustomerServiceGridInfoMessage">
    </app-information-note>
    <div class="table-tabs-container">
      <div class="table-tabs-header">
        <div class="table-tabs-title ibc-heading-h7-bold-subtitle">
          <span class="table-tab-name">{{ headerText.CustomerService }}</span>
          <app-svg-icon
            [iconName]="'infoCircle'"
            [isStaticSvg]="true"
            [isFrom]="'Page'"
            class="info-icon hawb-info-block cursor"
            matTooltipPosition="above"
            [matTooltip]="popupMessages.customerServiceMarkUpTooltip">
          </app-svg-icon>
        </div>
        <div class="tab-icons">
          <app-svg-icon
            [list]="customerServiceTableHeaderIcons"
            class="icon-section"
            (iconClicked)="onCustomerServiceIconClicked($event)"></app-svg-icon>
        </div>
      </div>
    </div>
    <app-add-inline-edit-table
      [inlineCrudTableCustomizeConfig]="customerServiceTableColumnConfig"
      [formConfig]="customerServiceFormConfig"
      [isFrom]="tableName.customerService"
      (inlineCrudTableFormValue)="onCustomerServiceFormFieldChange($event)"
      (inlineTableSelectionChange)="
        onCustomerServiceTableSelectionChange($event)
      "
      [pageMode]="customerServiceGridPageMode"
      [isEditIconClicked]="isEditClicked"
      [customerServiceAgentId]="customerServiceAgentId">
    </app-add-inline-edit-table>
  </div>
</div>
